import { c as e } from "react/compiler-runtime";
import { createContext as t, useContext as n, useEffect as r, useImperativeHandle as i, useRef as a, useState as o, useSyncExternalStore as s } from "react";
import { AgxCheckbox as c, AgxDatePicker as l, AgxDropdown as u, AgxSpacer as d, AgxTextInput as f, AgxTypography as p, Icon_AlertCircleOutline as m, SAVE_BUTTON_STATES as h, toDateOnlyString as g } from "@urbanx/agx.ui-components2";
import { jsx as _, jsxs as v } from "react/jsx-runtime";
import { revalidateLogic as y, useForm as b } from "@tanstack/react-form";
import { dequal as x } from "dequal";
//#region src/adapters/backendForm.ts
var S = (e, t) => {
	let n = e;
	for (let e of t.split(".")) {
		if (typeof n != "object" || !n) return { found: !1 };
		let t = (Array.isArray(n) ? [...Object.keys(n), "length"] : Object.keys(n)).find((t) => t.toLowerCase() === e.toLowerCase());
		if (!t) return { found: !1 };
		n = n[t];
	}
	return {
		found: !0,
		value: n
	};
}, C = (e) => e == null || typeof e == "object" && Object.keys(e).length === 0, w = (e, t) => {
	if (!e.key || !e.operator) throw Error("Backend form condition expressions require a key and operator");
	let n = S(t, e.key);
	if (!n.found) return !1;
	switch (String(e.operator)) {
		case "EQ": return n.value == e.value || C(n.value) && C(e.value);
		case "NEQ": return n.value != e.value;
		case "GT": return n.value > e.value;
		case "GTEQ": return n.value >= e.value;
		case "LT": return n.value < e.value;
		case "LTEQ": return n.value <= e.value;
		default: throw Error(`Unsupported backend form condition operator: ${e.operator}`);
	}
}, T = (e, t) => e?.some((e) => {
	if (!e.andOr || !e.expressions) throw Error("Backend form conditions require andOr and expressions");
	if (String(e.andOr) === "And") return e.expressions.every((e) => w(e, t));
	if (String(e.andOr) === "Or") return e.expressions.some((e) => w(e, t));
	throw Error(`Unsupported backend form condition conjunction: ${e.andOr}`);
}) ?? !1, E = (e, t) => !T(e.hideConditions, t), D = (e, t) => {
	let n = E(e.page, t) && !T(e.source.hideConditions, t);
	return {
		active: n,
		visible: n,
		disabled: !!e.source.disabled || T(e.source.disableConditions, t),
		required: n && (!!e.source.required || T(e.source.requiredConditions, t))
	};
}, O = ({ pages: e, resolvePath: t }) => {
	let n = e.flatMap((e) => (e.elements ?? []).map((n) => {
		if (!n.id) throw Error("Backend form elements require an id");
		return {
			id: n.id,
			label: n.label,
			path: t(n, e),
			source: n,
			page: e
		};
	})), r = new Map(n.map((e) => [e.path, e]));
	if (r.size !== n.length) throw Error("Backend form elements must resolve to unique field paths");
	let i = e.map((e) => {
		if (!e.name) throw Error("Backend form pages require a name");
		let t = n.filter((t) => t.page === e).map(({ id: e, label: t, path: n, source: r }) => ({
			id: e,
			label: t,
			path: n,
			source: r
		}));
		return {
			id: e.name,
			title: e.title,
			paths: t.map(({ path: e }) => e),
			elements: t,
			source: e
		};
	});
	return {
		pages: i,
		fieldOrder: n.map(({ path: e }) => e),
		resolveField: (e, t) => {
			let n = r.get(e);
			if (!n) throw Error(`Backend form field path is not defined: ${e}`);
			return D(n, t);
		},
		resolveFields: (e) => Object.fromEntries(n.map((t) => [t.path, D(t, e)])),
		resolvePages: (e) => i.filter(({ source: t }) => E(t, e))
	};
}, k = (t) => {
	let n = e(23), { id: r, label: i, labelHintText: a, hintText: o, optionalText: s, hideOptionalText: c, required: l, disabled: u, errorText: f, children: h } = t, g = s === void 0 ? "Optional" : s, y = c !== void 0 && c, b = !!(i || a || !l && !y), x;
	n[0] !== u || n[1] !== y || n[2] !== r || n[3] !== i || n[4] !== a || n[5] !== g || n[6] !== l || n[7] !== b ? (x = b && /* @__PURE__ */ v(d, {
		direction: "horizontal",
		gap: "spacing-2xl",
		contentAlignment: "center",
		contentJustification: "space-between",
		fill: !0,
		children: [/* @__PURE__ */ v(d, {
			direction: "horizontal",
			gap: "spacing-xs",
			contentAlignment: "center",
			children: [
				i && /* @__PURE__ */ _(p, {
					id: `${r}-label`,
					type: "label",
					size: "medium",
					color: u ? "var(--text-disabled)" : "var(--text-primary)",
					htmlFor: r,
					children: i
				}),
				l && i && /* @__PURE__ */ _(p, {
					id: `${r}-required-indicator`,
					type: "label",
					size: "medium",
					color: "var(--text-brand-accent)",
					children: "*"
				}),
				a && /* @__PURE__ */ _(p, {
					id: `${r}-label-hint`,
					type: "caption",
					size: "medium",
					color: "var(--text-tertiary)",
					children: a
				})
			]
		}), !l && !y && /* @__PURE__ */ _(p, {
			id: `${r}-optional`,
			type: "caption",
			size: "medium",
			color: "var(--text-tertiary)",
			children: g
		})]
	}), n[0] = u, n[1] = y, n[2] = r, n[3] = i, n[4] = a, n[5] = g, n[6] = l, n[7] = b, n[8] = x) : x = n[8];
	let S;
	n[9] !== u || n[10] !== f || n[11] !== o || n[12] !== r ? (S = o && (!f || u) && /* @__PURE__ */ _(p, {
		id: `${r}-description`,
		type: "body_ui",
		size: "small",
		color: "var(--text-tertiary)",
		children: o
	}), n[9] = u, n[10] = f, n[11] = o, n[12] = r, n[13] = S) : S = n[13];
	let C;
	n[14] !== u || n[15] !== f || n[16] !== r ? (C = f && !u && /* @__PURE__ */ v(d, {
		direction: "horizontal",
		gap: "spacing-sm",
		contentAlignment: "center",
		children: [/* @__PURE__ */ _(m, {
			type: "Danger",
			width: 16,
			height: 16
		}), /* @__PURE__ */ _(p, {
			id: `${r}-error`,
			dataTestId: `error-${r}`,
			type: "form_error",
			size: "small",
			color: "var(--text-error)",
			role: "alert",
			children: f
		})]
	}), n[14] = u, n[15] = f, n[16] = r, n[17] = C) : C = n[17];
	let w;
	return n[18] !== h || n[19] !== x || n[20] !== S || n[21] !== C ? (w = /* @__PURE__ */ v(d, {
		direction: "vertical",
		gap: "spacing-sm",
		fill: !0,
		children: [
			x,
			h,
			S,
			C
		]
	}), n[18] = h, n[19] = x, n[20] = S, n[21] = C, n[22] = w) : w = n[22], w;
}, A = (e) => {
	if (typeof e == "string") return e;
	if (e && typeof e == "object" && "message" in e) return String(e.message);
}, j = class {
	snapshot;
	listeners = /* @__PURE__ */ new Set();
	locations = /* @__PURE__ */ new Map();
	constructor(e) {
		this.snapshot = {
			baseline: e,
			issues: [],
			submitAttempted: !1,
			phase: "idle",
			blockers: [],
			revision: 0
		};
	}
	subscribe = (e) => (this.listeners.add(e), () => this.listeners.delete(e));
	getSnapshot = () => this.snapshot;
	setIssues(e) {
		this.update({ issues: e });
	}
	clearServerIssuesForPath(e) {
		let t = (t) => t === e || t.startsWith(`${e}.`) || t.startsWith(`${e}[`) || e.startsWith(`${t}.`) || e.startsWith(`${t}[`), n = this.snapshot.issues.filter((e) => e.source !== "server" || e.path === "$form" || !t(String(e.path)));
		n.length !== this.snapshot.issues.length && this.update({ issues: n });
	}
	setSubmitAttempted(e) {
		this.update({ submitAttempted: e });
	}
	setPhase(e) {
		this.update({ phase: e });
	}
	advanceBaseline(e) {
		this.update({
			baseline: e,
			issues: [],
			submitAttempted: !1,
			phase: "succeeded"
		});
	}
	replacePristineSource(e) {
		this.update({
			baseline: e,
			issues: [],
			submitAttempted: !1,
			phase: "idle"
		});
	}
	addBlocker(e) {
		if (this.snapshot.blockers.some(({ id: t }) => t === e.id)) throw Error(`A form blocker with id "${e.id}" is already registered.`);
		this.update({ blockers: [...this.snapshot.blockers, e] });
		let t = !0;
		return () => {
			t && (t = !1, this.update({ blockers: this.snapshot.blockers.filter((t) => t !== e) }));
		};
	}
	registerLocation(e) {
		let t = e.id;
		if (this.locations.has(t)) throw Error(`A form location for "${t}" is already registered.`);
		this.locations.set(t, e);
		let n = !0;
		return () => {
			n && (n = !1, this.locations.get(t) === e && this.locations.delete(t));
		};
	}
	async reveal(e) {
		await this.revealPath(String(e.path));
	}
	async revealPath(e) {
		let t = [...this.locations.values()].filter((t) => e === t.pathPrefix || e.startsWith(`${t.pathPrefix}.`) || e.startsWith(`${t.pathPrefix}[`)).sort((e, t) => e.order - t.order);
		for (let e of t) await e.reveal?.();
		await t.at(-1)?.focus?.();
	}
	update(e) {
		this.snapshot = {
			...this.snapshot,
			...e,
			revision: this.snapshot.revision + 1
		}, this.listeners.forEach((e) => e());
	}
}, M = (e) => {
	if (!e || typeof e != "object") return !1;
	let t = Object.getPrototypeOf(e);
	return t === Object.prototype || t === null;
}, N = (e) => e instanceof Date ? new Date(e.getTime()) : e instanceof Map ? new Map([...e.entries()].map(([e, t]) => [N(e), N(t)])) : e instanceof Set ? new Set([...e].map(N)) : Array.isArray(e) ? e.map(N) : M(e) ? Object.fromEntries(Object.entries(e).map(([e, t]) => [e, N(t)])) : e, P = (e, { defaultValues: t, disableWhileSubmitting: n = !1, onSubmit: i }) => {
	let [c] = o(() => new j(t)), l = a(0), u = a(void 0), d = s(c.subscribe, c.getSnapshot, c.getSnapshot), f = b({
		formId: e.id,
		defaultValues: d.baseline,
		validationLogic: y({
			mode: "change",
			modeAfterSubmission: "change"
		}),
		validators: { onDynamic: e.schema },
		onSubmit: async ({ value: t }) => {
			if (c.getSnapshot().blockers.length > 0) {
				c.setPhase("blocked");
				return;
			}
			let n = ++l.current, r = u.current ?? N(t);
			c.setPhase("submitting");
			let a;
			try {
				a = await i({
					values: r,
					parsedValues: e.schema.parse(r)
				});
			} catch (e) {
				throw n === l.current && c.setPhase("failed"), e;
			}
			if (n !== l.current) return;
			let o = !x(f.store.state.values, r);
			if (a?.status === "failed") {
				c.setPhase("failed");
				return;
			}
			if (a?.status === "rejected") {
				if (o) {
					c.setPhase("idle");
					return;
				}
				c.setIssues(a.issues), c.setPhase("failed"), a.issues[0] && await c.reveal(a.issues[0]);
				return;
			}
			let s = a?.status === "accepted" && a.baseline !== void 0 ? a.baseline : r;
			o || f.reset(s), c.advanceBaseline(s);
		}
	}), p = s((e) => f.store.subscribe(e).unsubscribe, () => f.store.state, () => f.store.state), m = p.values;
	r(() => {
		x(t, c.getSnapshot().baseline) || x(f.store.state.values, c.getSnapshot().baseline) && (f.reset(t), c.replacePristineSource(t));
	}, [
		t,
		f,
		c
	]);
	let h = async () => {
		u.current = N(f.store.state.values), await f.handleSubmit();
		let t = Object.keys(f.state.fieldMeta).filter((e) => f.getFieldMeta(e)?.isValid === !1).map(String).sort((t, n) => {
			let r = (t) => e.fieldOrder.findIndex((e) => t === e || t.startsWith(`${e}.`)), i = r(t), a = r(n);
			return (i < 0 ? 2 ** 53 - 1 : i) - (a < 0 ? 2 ** 53 - 1 : a);
		})[0];
		t && await c.revealPath(t);
	}, g = !x(m, d.baseline), _ = e.resolveFields(m);
	return {
		form: f,
		values: m,
		baseline: d.baseline,
		isDirty: g,
		issues: d.issues,
		phase: d.phase,
		blockers: d.blockers,
		canSubmit: d.blockers.length === 0 && d.phase !== "submitting" && p.canSubmit,
		fieldState: (e) => {
			let t = _[e] ?? {
				active: !0,
				visible: !0,
				disabled: !1,
				required: !1
			};
			return {
				resolved: n && d.phase === "submitting" ? {
					...t,
					disabled: !0
				} : t,
				serverIssue: d.issues.find(({ path: t }) => t === e)
			};
		},
		submit: h,
		accept: (e = f.state.values) => {
			f.reset(e), c.advanceBaseline(e);
		},
		reconcileSource: (e) => x(f.state.values, c.getSnapshot().baseline) ? (f.reset(e), c.replacePristineSource(e), !0) : !1,
		addBlocker: (e) => c.addBlocker(e),
		registerLocation: (e) => c.registerLocation(e),
		addServerIssues: (e) => c.setIssues(e),
		clearServerIssuesForPath: (e) => c.clearServerIssuesForPath(String(e))
	};
}, F = (i) => {
	let o = Symbol("AgxFormDefinition"), s = (t) => {
		let n = e(2), r = P(i, t), a;
		return n[0] === r ? a = n[1] : (a = {
			...r,
			definitionIdentity: o
		}, n[0] = r, n[1] = a), a;
	}, c = t(null), l = () => {
		let e = n(c);
		if (!e) throw Error("A bound form component must be rendered inside its Form.Root.");
		if (e.definitionIdentity !== o) throw Error("A bound form component received a form created by a different definition.");
		return e;
	};
	return {
		useForm: s,
		Root: (t) => {
			let n = e(13), r, i, a;
			if (n[0] === t ? (r = n[1], i = n[2], a = n[3]) : ({form: i, children: r, ...a} = t, n[0] = t, n[1] = r, n[2] = i, n[3] = a), i.definitionIdentity !== o) throw Error("Form.Root received a form created by a different definition.");
			let s;
			n[4] === i ? s = n[5] : (s = (e) => {
				e.preventDefault(), i.phase !== "submitting" && i.submit();
			}, n[4] = i, n[5] = s);
			let l;
			n[6] !== r || n[7] !== a || n[8] !== s ? (l = /* @__PURE__ */ _("form", {
				noValidate: !0,
				...a,
				onSubmit: s,
				children: r
			}), n[6] = r, n[7] = a, n[8] = s, n[9] = l) : l = n[9];
			let u;
			return n[10] !== i || n[11] !== l ? (u = /* @__PURE__ */ _(c.Provider, {
				value: i,
				children: l
			}), n[10] = i, n[11] = l, n[12] = u) : u = n[12], u;
		},
		Field: ({ name: e, Input: t, disabled: n, label: o, labelHintText: s, hintText: c, optionalText: u, hideOptionalText: d, ...f }) => {
			let p = l(), m = a(null), h = p.fieldState(e);
			return r(() => p.registerLocation({
				id: `field:${String(e)}`,
				pathPrefix: String(e),
				order: i.fieldOrder.indexOf(e),
				focus: () => m.current?.focus()
			}), [p, e]), h.resolved.visible ? /* @__PURE__ */ _(p.form.Field, {
				name: e,
				children: (r) => {
					let i = (r.state.meta.isTouched || p.form.state.submissionAttempts > 0 ? A(r.state.meta.errors[0]) : void 0) ?? h.serverIssue?.message, a = h.resolved.disabled || !!n, l = Object.assign({}, f, {
						id: String(e),
						name: String(e),
						value: r.state.value,
						onChange: (t) => {
							a || (r.handleChange(t), p.clearServerIssuesForPath(e));
						},
						onBlur: r.handleBlur,
						disabled: a,
						required: h.resolved.required,
						invalid: !!i,
						ariaLabelledBy: o ? `${String(e)}-label` : void 0,
						ariaDescribedBy: [s ? `${String(e)}-label-hint` : void 0, i && !a ? `${String(e)}-error` : c ? `${String(e)}-description` : void 0].filter(Boolean).join(" ") || void 0,
						fieldRef: m
					});
					return /* @__PURE__ */ _(k, {
						id: String(e),
						label: o,
						labelHintText: s,
						hintText: c,
						optionalText: u,
						hideOptionalText: d,
						required: h.resolved.required,
						disabled: a,
						errorText: i,
						children: /* @__PURE__ */ _(t, { ...l })
					});
				}
			}) : null;
		},
		CustomField: (t) => {
			let n = e(21), { name: a, focus: o, reveal: s, children: c } = t, u = l(), d;
			n[0] !== u || n[1] !== a ? (d = u.fieldState(a), n[0] = u, n[1] = a, n[2] = d) : d = n[2];
			let f = d, p, m;
			if (n[3] !== o || n[4] !== u || n[5] !== a || n[6] !== s ? (p = () => u.registerLocation({
				id: `custom-field:${String(a)}`,
				pathPrefix: String(a),
				order: i.fieldOrder.indexOf(a),
				focus: o,
				reveal: s
			}), m = [
				o,
				u,
				a,
				s
			], n[3] = o, n[4] = u, n[5] = a, n[6] = s, n[7] = p, n[8] = m) : (p = n[7], m = n[8]), r(p, m), !f.resolved.visible) return null;
			let h;
			n[9] !== c || n[10] !== u || n[11] !== a || n[12] !== f.resolved.disabled || n[13] !== f.resolved.required || n[14] !== f.resolved.visible || n[15] !== f.serverIssue?.message ? (h = (e) => {
				let t = (e.state.meta.isTouched || u.form.state.submissionAttempts > 0 ? A(e.state.meta.errors[0]) : void 0) ?? f.serverIssue?.message;
				return c({
					id: String(a),
					name: a,
					value: e.state.value,
					onChange: (t) => {
						f.resolved.disabled || (e.handleChange(t), u.clearServerIssuesForPath(a));
					},
					onBlur: e.handleBlur,
					disabled: f.resolved.disabled,
					required: f.resolved.required,
					visible: f.resolved.visible,
					errorText: t,
					hasError: !!t
				});
			}, n[9] = c, n[10] = u, n[11] = a, n[12] = f.resolved.disabled, n[13] = f.resolved.required, n[14] = f.resolved.visible, n[15] = f.serverIssue?.message, n[16] = h) : h = n[16];
			let g;
			return n[17] !== u.form.Field || n[18] !== a || n[19] !== h ? (g = /* @__PURE__ */ _(u.form.Field, {
				name: a,
				children: h
			}), n[17] = u.form.Field, n[18] = a, n[19] = h, n[20] = g) : g = n[20], g;
		},
		Submit: (t) => {
			let n = e(6), { children: r } = t, i = l(), a;
			return n[0] !== r || n[1] !== i.canSubmit || n[2] !== i.isDirty || n[3] !== i.phase || n[4] !== i.submit ? (a = r({
				submit: i.submit,
				phase: i.phase,
				canSubmit: i.canSubmit,
				isDirty: i.isDirty
			}), n[0] = r, n[1] = i.canSubmit, n[2] = i.isDirty, n[3] = i.phase, n[4] = i.submit, n[5] = a) : a = n[5], a;
		}
	};
}, I = ({ id: e, schema: t, resolveFields: n = () => ({}), fieldOrder: r = [] }) => ({
	id: e,
	schema: t,
	resolveFields: n,
	fieldOrder: r
}), L = (t) => {
	let n = e(2), r = a(null), o;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (o = (e) => {
		r.current = e;
	}, n[0] = o) : o = n[0];
	let s = o, c;
	return n[1] === Symbol.for("react.memo_cache_sentinel") ? (c = () => ({ focus: () => r.current?.focus() }), n[1] = c) : c = n[1], i(t, c), s;
}, R = (t) => {
	let n = e(33), r, i, a, o, s, c, l, u, d, p, m, h;
	if (n[0] !== t) {
		let { id: e, value: f, onChange: g, onBlur: _, disabled: v, required: y, invalid: b, ariaLabelledBy: x, ariaDescribedBy: S, onValueChange: C, fieldRef: w, name: T, ...E } = t;
		s = e, h = f, u = g, l = _, a = v, m = y, c = b, i = x, r = S, d = C, o = w, p = E, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c, n[7] = l, n[8] = u, n[9] = d, n[10] = p, n[11] = m, n[12] = h;
	} else r = n[1], i = n[2], a = n[3], o = n[4], s = n[5], c = n[6], l = n[7], u = n[8], d = n[9], p = n[10], m = n[11], h = n[12];
	let g = L(o), v = `${s}-wrapper`, y;
	n[13] !== u || n[14] !== d ? (y = (e) => {
		u(e), d?.(e);
	}, n[13] = u, n[14] = d, n[15] = y) : y = n[15];
	let b;
	n[16] !== l || n[17] !== u || n[18] !== d ? (b = (e) => {
		let { value: t } = e;
		u(t), d?.(t), l();
	}, n[16] = l, n[17] = u, n[18] = d, n[19] = b) : b = n[19];
	let x;
	return n[20] !== r || n[21] !== i || n[22] !== a || n[23] !== s || n[24] !== g || n[25] !== c || n[26] !== p || n[27] !== m || n[28] !== v || n[29] !== y || n[30] !== b || n[31] !== h ? (x = /* @__PURE__ */ _(f, {
		...p,
		id: v,
		inputId: s,
		ref: g,
		defaultValue: h,
		disableValidation: !0,
		disableLabelRendering: !0,
		disableErrorRendering: !0,
		disabled: a,
		required: m,
		hasError: c,
		ariaLabelledBy: i,
		ariaDescribedBy: r,
		onChange: y,
		onInputValueChange: b
	}), n[20] = r, n[21] = i, n[22] = a, n[23] = s, n[24] = g, n[25] = c, n[26] = p, n[27] = m, n[28] = v, n[29] = y, n[30] = b, n[31] = h, n[32] = x) : x = n[32], x;
}, z = (t) => {
	let n = e(27), r, i, a, o, s, c, l, d, f, p, m;
	if (n[0] !== t) {
		let { id: e, value: u, onChange: h, onBlur: g, disabled: _, required: v, invalid: y, ariaLabelledBy: b, ariaDescribedBy: x, fieldRef: S, name: C, ...w } = t;
		s = e, m = u, d = h, l = g, a = _, p = v, c = y, i = b, r = x, o = S, f = w, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c, n[7] = l, n[8] = d, n[9] = f, n[10] = p, n[11] = m;
	} else r = n[1], i = n[2], a = n[3], o = n[4], s = n[5], c = n[6], l = n[7], d = n[8], f = n[9], p = n[10], m = n[11];
	let h = L(o), g = `${s}-wrapper`, v;
	n[12] !== l || n[13] !== d ? (v = (e) => {
		d(e), l();
	}, n[12] = l, n[13] = d, n[14] = v) : v = n[14];
	let y;
	return n[15] !== r || n[16] !== i || n[17] !== a || n[18] !== s || n[19] !== h || n[20] !== c || n[21] !== f || n[22] !== p || n[23] !== g || n[24] !== v || n[25] !== m ? (y = /* @__PURE__ */ _(u, {
		...f,
		id: g,
		inputId: s,
		inputRef: h,
		selected: m,
		disableLabelRendering: !0,
		disableErrorRendering: !0,
		disabled: a,
		required: p,
		hasError: c,
		ariaLabelledBy: i,
		ariaDescribedBy: r,
		onChange: v
	}), n[15] = r, n[16] = i, n[17] = a, n[18] = s, n[19] = h, n[20] = c, n[21] = f, n[22] = p, n[23] = g, n[24] = v, n[25] = m, n[26] = y) : y = n[26], y;
}, B = (t) => {
	let n = e(27), r, i, a, o, s, l, u, d, f, p, m;
	if (n[0] !== t) {
		let { id: e, value: c, onChange: h, onBlur: g, disabled: _, required: v, invalid: y, ariaLabelledBy: b, ariaDescribedBy: x, fieldRef: S, name: C, ...w } = t;
		s = e, m = c, d = h, u = g, a = _, p = v, l = y, i = b, r = x, o = S, f = w, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = l, n[7] = u, n[8] = d, n[9] = f, n[10] = p, n[11] = m;
	} else r = n[1], i = n[2], a = n[3], o = n[4], s = n[5], l = n[6], u = n[7], d = n[8], f = n[9], p = n[10], m = n[11];
	let h = L(o), g = `${s}-wrapper`, v;
	n[12] !== u || n[13] !== d ? (v = (e) => {
		d(e), u();
	}, n[12] = u, n[13] = d, n[14] = v) : v = n[14];
	let y;
	return n[15] !== r || n[16] !== i || n[17] !== a || n[18] !== s || n[19] !== h || n[20] !== l || n[21] !== f || n[22] !== p || n[23] !== g || n[24] !== v || n[25] !== m ? (y = /* @__PURE__ */ _(c, {
		...f,
		type: "checkbox",
		id: g,
		inputId: s,
		inputRef: h,
		checked: m,
		disableLabelRendering: !0,
		disableErrorRendering: !0,
		disabled: a,
		required: p,
		hasError: l,
		ariaLabelledBy: i,
		ariaDescribedBy: r,
		onChange: v
	}), n[15] = r, n[16] = i, n[17] = a, n[18] = s, n[19] = h, n[20] = l, n[21] = f, n[22] = p, n[23] = g, n[24] = v, n[25] = m, n[26] = y) : y = n[26], y;
}, V = (t) => {
	let n = e(31), r, i, a, o, s, c, u, d, f, p, m;
	if (n[0] !== t) {
		let { id: e, value: l, onChange: h, onBlur: g, disabled: _, required: v, invalid: y, ariaLabelledBy: b, ariaDescribedBy: x, fieldRef: S, name: C, ...w } = t;
		s = e, m = l, d = h, u = g, a = _, p = v, c = y, i = b, r = x, o = S, f = w, n[0] = t, n[1] = r, n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c, n[7] = u, n[8] = d, n[9] = f, n[10] = p, n[11] = m;
	} else r = n[1], i = n[2], a = n[3], o = n[4], s = n[5], c = n[6], u = n[7], d = n[8], f = n[9], p = n[10], m = n[11];
	let h = L(o), v = `${s}-wrapper`, y;
	n[12] !== u || n[13] !== d ? (y = (e) => {
		d(e), u();
	}, n[12] = u, n[13] = d, n[14] = y) : y = n[14];
	let b;
	n[15] !== u || n[16] !== d ? (b = (e) => {
		d(e ? g(e) ?? null : null), u();
	}, n[15] = u, n[16] = d, n[17] = b) : b = n[17];
	let x;
	return n[18] !== r || n[19] !== i || n[20] !== a || n[21] !== s || n[22] !== h || n[23] !== c || n[24] !== f || n[25] !== p || n[26] !== v || n[27] !== y || n[28] !== b || n[29] !== m ? (x = /* @__PURE__ */ _(l, {
		...f,
		id: v,
		inputId: s,
		inputRef: h,
		value: m,
		outputFormat: "date",
		disableLabelRendering: !0,
		disableErrorRendering: !0,
		disableValidation: !0,
		onInvalidValue: y,
		disabled: a,
		required: p,
		hasError: c,
		ariaLabelledBy: i,
		ariaDescribedBy: r,
		onChange: b
	}), n[18] = r, n[19] = i, n[20] = a, n[21] = s, n[22] = h, n[23] = c, n[24] = f, n[25] = p, n[26] = v, n[27] = y, n[28] = b, n[29] = m, n[30] = x) : x = n[30], x;
}, H = (e, t) => e === "submitting" ? h.SAVING : t ? h.UNSAVED : e === "succeeded" ? h.SAVED : h.UNSAVED;
//#endregion
export { B as AgxFormCheckbox, V as AgxFormDateField, z as AgxFormDropdown, R as AgxFormTextField, T as backendConditionsAreMet, F as createAgxForm, O as createBackendFormAdapter, I as createFormDefinition, H as saveButtonStateFor };
